<template>
  <svg
    :aria-label="title"
    role="presentation"
    class="icon"
  >
    <title
      v-if="title"
      lang="nl"
    >
      {{ title }}
    </title>
    <g>
      <use :xlink:href="'#' + icon" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'KfIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="postcss">
.icon {
  @apply w-8 h-8;
}
</style>
